import { renderIcon } from '@/utils/index';
import { DashboardOutlined, TableOutlined } from '@vicons/antd';

//前端路由图标映射表
export const constantRouterIcon = {
  DashboardOutlined: renderIcon(DashboardOutlined),
  TableOutlined: renderIcon(TableOutlined),
};
